// components/industry-templates/ChemicalsEventTemplate.tsx
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { FlaskConical, TestTube, Beaker, Award } from 'lucide-react';

export const ChemicalsEventTemplate = ({ structure, theme }: any) => {
  const industryData = structure.industry_data;

  return (
    <div className="space-y-8">
      <Card className="border-0 bg-gradient-to-br from-purple-600/20 to-pink-600/20 backdrop-blur">
        <CardHeader>
          <CardTitle className="text-white flex items-center gap-2 text-2xl">
            <FlaskConical className="w-8 h-8" style={{ color: theme.primary }} />
            Chemical Innovations
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-2 gap-4">
            {industryData?.chemical_innovations?.map((innovation: any, idx: number) => (
              <div key={idx} className="p-5 bg-white/10 rounded-xl">
                <h3 className="text-xl font-bold text-white mb-2">{innovation.name}</h3>
                <p className="text-slate-300 text-sm mb-3">{innovation.application}</p>
                <Badge style={{ backgroundColor: theme.primary }}>{innovation.category}</Badge>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
